// extracted by mini-css-extract-plugin
module.exports = {"content":"AccessKeyContent_content__2fWI5","activate":"AccessKeyContent_activate__iM0Wx","deactivate":"AccessKeyContent_deactivate__1G1cG"};